import { createPersistentKeyValueLocalStorage } from '@orionprotocol/storage';

export const keyValueStorage = createPersistentKeyValueLocalStorage();
